import React, { useEffect, useState, useMemo } from "react";
import { getAuth } from "firebase/auth";
import DashboardLayout from "../dashboard/layout";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
    FiPlus,
    FiTrash2,
    FiEdit,
    FiUpload,
    FiSave,
    FiX,
    FiSettings,
    FiMenu,
    FiSearch,
    FiCheckCircle,
    FiAlertTriangle,
    FiArrowRight,
    FiHash
} from "react-icons/fi";

// Firebase Firestore Imports
import {
    doc,
    updateDoc,
    deleteDoc,
    addDoc,
    getFirestore,
    collection,
    getDocs,
    writeBatch,
    getDoc
} from "firebase/firestore";

import "./Settings.module.css";

const MySwal = withReactContent(Swal);

const Blocked = () => {
    // --- State Variables ---
    const [registeredCars, setRegisteredCars] = useState([]);
    const [searchPlate, setSearchPlate] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const pageSize = 100;

    // Modal & Edit States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingCar, setEditingCar] = useState(null);
    const [formData, setFormData] = useState({ plate: "", desc: "", });

    // --- Excel Upload & Preview States ---
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewData, setPreviewData] = useState({ newRecords: [], updatedRecords: [] });
    const [previewExcelDuplicates, setPreviewExcelDuplicates] = useState([]); // [{plate, count}]
    const [isUploading, setIsUploading] = useState(false);
    const [searchNumber, setSearchNumber] = useState("");



    // Firebase Init
    const db = getFirestore();
    const auth = getAuth();

    // --- Үндсэн функцууд ---
    const toggleSidebar = () => {
        const newState = !sidebarOpen;
        setSidebarOpen(newState);
        localStorage.setItem('sidebar', newState);
    };

    useEffect(() => {
        fetchRegisteredCars();
    }, []);

    // 1. Бүх машиныг татах
    const fetchRegisteredCars = async () => {
        if (!auth.currentUser) return;
        const recordsColRef = collection(db, "parkings", auth.currentUser.displayName, "blockedCars");
     

        try {
            const snapshot = await getDocs(recordsColRef);
            const allCars = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setRegisteredCars(allCars);
        } catch (error) {
            console.error("Машины мэдээлэл татахад алдаа гарлаа:", error);
        }
    };



    const toggleBlockCar = async (car) => {
    // 1. Баталгаажуулах цонх
    const result = await MySwal.fire({
        title: car.isBlocked ? 'Машиныг идэвхжүүлэх' : 'Машиныг блоклох',
        text: car.isBlocked 
            ? "Энэ машин зогсоолд нэвтрэх эрхтэй болно." 
            : "Энэ машин зогсоолд нэвтрэх боломжгүй болно.",
        icon: car.isBlocked ? 'question' : 'warning',
        showCancelButton: true,
        confirmButtonColor: car.isBlocked ? '#10b981' : '#ef4444', // Green for unblock, Red for block
        cancelButtonColor: '#64748b',
        confirmButtonText: car.isBlocked ? 'Тийм' : 'Тийм',
        cancelButtonText: 'Цуцлах',
        customClass: { popup: "small-swal-popup" }
    });

    // 2. Хэрэв зөвшөөрсөн бол үйлдэл хийнэ
    if (result.isConfirmed) {
        try {
            const carRef = doc(db, "parkings", auth.currentUser.displayName, "blockedCars", car.id);
            await updateDoc(carRef, {
                isBlocked: !car.isBlocked,
                updatedAt: new Date()
            });            
            fetchRegisteredCars(); 
        } catch (e) {
            console.error("Block toggle error", e);
            MySwal.fire('Алдаа!', 'Үйлдэл амжилтгүй боллоо.', 'error');
        }
    }
};




    // --- Helper Function: Format Plate ---
    const formatPlate = (plate) => {
        if (!plate) return "";
        let cleaned = String(plate).trim().toUpperCase().replace(/\s/g, '');
        // Remove possible hyphens or other separators often used
        cleaned = cleaned.replace(/[-·•]/g, '');
        return cleaned; // 5050УБА
    };

    const formatDate = (dateInput) => {
    if (!dateInput) return "-";

    // Firebase Timestamp бол .toDate() ашиглана, үгүй бол шууд Date объект гэж үзнэ
    const date = dateInput.toDate ? dateInput.toDate() : new Date(dateInput);

    const year = date.getFullYear();
    // Сар 0-ээс эхэлдэг тул +1 нэмнэ. padStart(2, '0') нь 1 оронтой тоог 0-ээр эхлүүлнэ (жнь: 5 -> 05)
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}/${month}/${day} ${hours}:${minutes}`;
};

    // --- CRUD Үйлдлүүд ---
    const openModal = (car = null) => {
        if (car) {
            setEditingCar(car);
            setFormData({
                plate: car.plate || "",
                desc: car.desc || "",
            });
        } else {
            setEditingCar(null);
            setFormData({ plate: "", desc: "" });
        }
        setIsModalOpen(true);
    };

    const handleSaveCar = async () => {
        if (!formData.plate) return MySwal.fire({ icon: "info", title: "Машины дугаар оруулна уу!" });

        const formattedPlate = formatPlate(formData.plate);

        if (formattedPlate.length !== 7 || !formattedPlate.match(/^(\d{4})([A-ZА-ЯӨҮ]{3})$/)) {
            MySwal.fire({ icon: "info", title: "Дугаар буруу форматтай байна (Жишээ: 5050УБА)" });
            return;
        }

        // Check Duplicate manually
        const isDuplicate = registeredCars.some(car => {
            const existingPlate = formatPlate(car.plate);
            if (editingCar) return existingPlate === formattedPlate && car.id !== editingCar.id;
            return existingPlate === formattedPlate;
        });

        if (isDuplicate) {
            MySwal.fire({ icon: "warning", title: `"${formattedPlate}" дугаар бүртгэлтэй байна!` });
            return;
        }

        const currentUser = auth.currentUser;
        if (!currentUser) return;
        const colRef = collection(db, "parkings", currentUser.displayName,"blockedCars");

        try {
            if (editingCar) {
                const carRef = doc(db, "parkings", currentUser.displayName,  "blockedCars", editingCar.id);
                await updateDoc(carRef, {
                    ...formData,
                    plate: formattedPlate,
                    isBlocked: editingCar.isBlocked ?? false,
                    updatedAt: new Date()
                });
                MySwal.fire({ icon: "success", title: "Амжилттай шинэчиллээ!" });
            } else {
                await addDoc(colRef, {
                    ...formData,
                    plate: formattedPlate,
                    isBlocked: false, 
                    createdAt: new Date()
                });
                MySwal.fire({ icon: "success", title: "Амжилттай нэмэгдлээ!" });
            }
            setIsModalOpen(false);
            fetchRegisteredCars();
        } catch (error) {
            MySwal.fire({ icon: "error", title: "Алдаа гарлаа" });
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Устгахдаа итгэлтэй байна уу?")) return;
        try {
            const carRef = doc(db, "parkings", auth.currentUser.displayName, "blockedCars", id);
            await deleteDoc(carRef);
            fetchRegisteredCars();
        } catch (error) {
            console.error("Delete error:", error);
        }
    };

    // --- EXCEL UPLOAD & COMPARE LOGIC (Сайжруулсан хэсэг) ---



    // 4. Batch Upload хийх (Баталгаажуулсан үед)
    const confirmBatchUpload = async () => {
        setIsUploading(true);
        const batch = writeBatch(db);
        const currentUser = auth.currentUser;
        if (!currentUser) {
            MySwal.fire({ icon: "error", title: "Хэрэглэгч олдсонгүй" });
            setIsUploading(false);
            return;
        }

        try {
            // 1. Шинэ бичлэгүүдийг нэмэх
            // Ensure we don't accidentally try to add duplicates (should already be deduped by processExcelData)
            const newPlatesSet = new Set();
            previewData.newRecords.forEach(car => {
                if (newPlatesSet.has(car.plate)) return;
                newPlatesSet.add(car.plate);
                const newDocRef = doc(collection(db, "parkings", currentUser.displayName, "blockedCars"));
                batch.set(newDocRef, { ...car, createdAt: new Date() });
            });

            // 2. Шинэчлэгдэж буй бичлэгүүдийг засах
            const updatedIdsSet = new Set();
            previewData.updatedRecords.forEach(item => {
                if (updatedIdsSet.has(item.id)) return;
                updatedIdsSet.add(item.id);
                const docRef = doc(db, "parkings", currentUser.displayName, "blockedCars", item.id);
                batch.update(docRef, { ...item.new, updatedAt: new Date() });
            });

            await batch.commit();

            MySwal.fire({
                title: `<span>Амжилттай!</span>`,
                html: `Нэмсэн: <b>${previewData.newRecords.length}</b><br/>Шинэчилсэн: <b>${previewData.updatedRecords.length}</b>`,
                icon: "success",
                confirmButtonColor: "#0b6df7ff"
            });

            setIsPreviewOpen(false);
    
            setPreviewExcelDuplicates([]);
            fetchRegisteredCars();
        } catch (error) {
            console.error("Upload error", error);
            MySwal.fire({ title: "Хуулахад алдаа гарлаа", icon: "error" });
        } finally {
            setIsUploading(false);
        }
    };

    // --- Pagination Logic ---
    const filteredLogs = useMemo(() => {
        return registeredCars.filter((car) => {
            // 1. Улсын дугаараар шүүх
            const carPlate = String(car.plate || "").toLowerCase().replace(/\s/g, "");
            const plateKeyword = searchPlate.toLowerCase().replace(/\s/g, "");
            const matchPlate = !plateKeyword || carPlate.includes(plateKeyword);

            // 2. Тоотоор шүүх
            const carNumber = String(car.number || "").toLowerCase();
            const numberKeyword = searchNumber.toLowerCase().replace(/\s/g, "");
            const matchNumber = !numberKeyword || carNumber.includes(numberKeyword);

            // Хоёулаа таарч байвал буцаана (AND нөхцөл)
            return matchPlate && matchNumber;
        });
    }, [registeredCars, searchPlate, searchNumber]);

    const totalPages = Math.max(1, Math.ceil(filteredLogs.length / pageSize));
    const paginatedLogs = filteredLogs.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const handlePrev = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNext = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));

    return (
        <DashboardLayout sidebarOpen={sidebarOpen}>
            <div className="dashboard">
                <div className="content-header">
                    <h2 className="dashboard-title">Хар жигсаалт</h2>
                </div>
                <div className="date-picker-settings" >
                    <div className="date-picker-wrapper" >
                        <button onClick={() => toggleSidebar()} className="sidebar-toggle-in-header-btn">
                            <FiMenu />
                        </button>
                    </div>
                </div>
                <div style={{ marginTop: '20px' }}></div>


                <hr style={{ borderTop: '1px solid #e2e8f0', margin: '2rem 0' }} />

                <h3 className="dashboard-subtitle">Бүртгэлтэй машинууд</h3>

                {/* --- CONTROL PANEL --- */}
                <div className="settings-controls-card">
                    {/* Add Manual */}
                    <div className="control-section">
                        <h4>Гар аргаар нэмэх</h4>
                        <button className="btn-primary" onClick={() => openModal()}>
                            <FiPlus /> Шинэ машин нэмэх
                        </button>
                    </div>
                </div>

                <hr style={{ borderTop: '1px solid #e2e8f0', margin: '2rem 0' }} />

                {/* --- TABLE & SEARCH --- */}
                <div className="search-row">

                    <div className="search-input-group">
                        <FiSearch className="search-icon" />
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Улсын дугаар..."
                            value={searchPlate}
                            onChange={e => { setSearchPlate(e.target.value); setCurrentPage(1); }}
                        />
                    </div>

                </div>

                <div className="table-responsive-wrapper">
                    <table className="dashboard-table">
                        <thead>
                            <tr>
                                <th>№</th>
                                <th>Огноо</th>
                                <th>Шалтгаан</th>
                                <th>Улсын дугаар</th>
                                 <th>Төлөв</th>
                                <th>Үйлдэл</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedLogs.map((car, idx) => (
                                <tr key={car.id}>
                                    <td>{(currentPage - 1) * pageSize + idx + 1}</td>
                                    <td>{formatDate(car.createdAt)}</td>
                                    <td>{car.desc}</td>
                                    <td><b>{car.plate}</b></td>
                                          <td>
                                {/* Text Status - Switch-ийн хажууд эсвэл тусдаа баганад байж болно */}
                            
                                    <span style={{ 
                                        color: "#ef4444", 
                                        fontWeight: 600, 
                                        fontSize: '12px',
                                        background: '#fef2f2',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        border: '1px solid #fee2e2'
                                    }}>
                                        Блоклосон
                                    </span>
                               
                            </td>
                                    <td>
                                        <div className="action-buttons">
                                            <button className="btn-icon edit" onClick={() => openModal(car)}><FiEdit /></button>
                                            <button className="btn-icon delete" onClick={() => handleDelete(car.id)}><FiTrash2 /></button>

                                        </div>
                                    </td>
                           
                      
                          
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination-controls" style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '16px' }}>
                    <button onClick={handlePrev} disabled={currentPage === 1}>{"<"}</button>
                    <span>{currentPage} / {totalPages}</span>
                    <button onClick={handleNext} disabled={currentPage === totalPages}>{">"}</button>
                </div>
            </div>

            {/* --- ADD/EDIT MODAL --- */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{editingCar ? "Машин засах" : "Машин нэмэх"}</h3>
                            <button onClick={() => setIsModalOpen(false)}><FiX size={24} /></button>
                        </div>
                        <div className="modal-body">
                            <input type="text" placeholder="Улсын дугаар (5050УБА)" value={formData.plate} onChange={e => setFormData({ ...formData, plate: e.target.value })} />
                            <input type="text" placeholder="Тайлбар" value={formData.desc} onChange={e => setFormData({ ...formData, desc: e.target.value })} />
                        </div>
                        <div className="modal-footer">
                            <button className="btn-secondary" onClick={() => setIsModalOpen(false)}>Болих</button>
                            <button className="btn-primary" onClick={handleSaveCar}>Хадгалах</button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- EXCEL PREVIEW MODAL (ШИНЭ) --- */}
            {isPreviewOpen && (
                <div className="modal-overlay" style={{ zIndex: 1001 }}>
                    <div className="modal-content" style={{ width: '90%', maxWidth: '1000px' }}>
                        <div className="modal-header">
                            <h3>
                                Excel өгөгдөл шалгах
                            </h3>
                            <button onClick={() => setIsPreviewOpen(false)}><FiX size={24} /></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>

                            {/* ---------- Excel-д davhardal байвал үзүүлэх хэсэг ---------- */}
                            {previewExcelDuplicates.length > 0 && (
                                <div style={{ marginBottom: "25px" }}>
                                    <h4 style={{ color: "#e11d48", display: "flex", alignItems: "center", gap: "8px" }}>
                                        <FiAlertTriangle /> Excel дотор давхардсан дугаарууд
                                    </h4>

                                    <table className="dashboard-table preview-table">
                                        <thead>
                                            <tr>
                                                <th>Дугаар</th>
                                                <th>Давхардсан тоо</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewExcelDuplicates.map((d, i) => (
                                                <tr key={i} style={{ background: "#fff1f2" }}>
                                                    <td style={{ color: "#be123c", fontWeight: "600" }}>{d.plate}</td>
                                                    <td>{d.count} удаа</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <p style={{ fontSize: "12px", color: "#666" }}>
                                        ⚠ Эдгээр дугаарууд Excel дотор өөрсдөө давхар орсон тул <b>анхны мөр</b>-ийг ашиглаж upload хийнэ.
                                    </p>
                                </div>
                            )}

                            {/* Section 1: Шинэчлэгдэх (Replace) - ХАЖУУД НЬ ХАРУУЛАХ ХЭСЭГ */}
                            {previewData.updatedRecords.length > 0 && (
                                <div style={{ marginBottom: '30px' }}>
                                    <h4 style={{ color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <FiAlertTriangle /> Шинэчлэгдэх машинууд (Replace) - {previewData.updatedRecords.length}
                                    </h4>
                                    <p style={{fontSize: '12px', color: '#666', marginBottom: '10px'}}>Эдгээр дугаарууд бүртгэлд байгаа тул Excel дээрх мэдээллээр солигдоно.</p>

                                    <table className="dashboard-table preview-table">
                                        <thead>
                                            <tr>
                                                <th>Дугаар</th>
                                                <th>Хуучин утга (DB)</th>
                                                <th></th>
                                                <th>Шинэ утга (Excel)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewData.updatedRecords.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td><strong>{item.new.plate}</strong></td>

                                                    {/* OLD DATA */}
                                                    <td style={{ backgroundColor: '#fff4f4', color: '#c53030' }}>
                                                        <small>Тайлбар:</small> {item.old.desc}<br/>
                                                    </td>

                                                    <td style={{ textAlign: 'center' }}><FiArrowRight color="#718096"/></td>

                                                    {/* NEW DATA */}
                                                    <td style={{ backgroundColor: '#f0fff4', color: '#276749' }}>
                                                        <small>Тайлбар:</small> {item.new.desc}<br/>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {/* Section 2: Шинээр нэмэгдэх */}
                            <div>
                                <h4 style={{ color: '#38a169', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <FiCheckCircle /> Шинээр нэмэгдэх - {previewData.newRecords.length}
                                </h4>
                                {previewData.newRecords.length > 0 ? (
                                    <table className="dashboard-table">
                                        <thead>
                                            <tr>
                                                <th>Дугаар</th>
                                                <th>Байр/Тоот</th>
                                                <th>Тайлбар</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewData.newRecords.map((car, idx) => (
                                                <tr key={idx}>
                                                    <td>{car.plate}</td>
                                                    <td>{car.building}-{car.number}</td>
                                                    <td>{car.desc}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p style={{fontStyle: 'italic', color: '#999'}}>Шинэ машин алга.</p>
                                )}
                            </div>

                        </div>
                        <div className="modal-footer">
                            <div style={{ marginRight: 'auto', fontSize: '14px' }}>
                                Нийт: <b>{previewData.newRecords.length + previewData.updatedRecords.length}</b> машин
                            </div>
                            <button className="btn-secondary" onClick={() => setIsPreviewOpen(false)}>Болих</button>
                            <button 
                                className="btn-primary" 
                                onClick={confirmBatchUpload}
                                disabled={isUploading || (previewData.newRecords.length === 0 && previewData.updatedRecords.length === 0)}
                            >
                                {isUploading ? "Уншиж байна..." : "Баталгаажуулах & Хадгалах"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </DashboardLayout>
    );
};

export default Blocked;
